import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    actions: {
      paddingTop: 43,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.up("mobile")]: {
        paddingTop: 46,
        paddingBottom: 68,
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        margin: [0, "auto"],
        width: 450,
      },
      [theme.breakpoints.up("tablet")]: {
        paddingTop: 46,
      },
    },
    action: {
      marginBottom: 34,
      [theme.breakpoints.up("mobile")]: {
        "&:first-child": {
          marginLeft: 0,
        },
        marginLeft: 10,
      },
      [theme.breakpoints.up("tablet")]: {
        "&:first-child": {
          marginLeft: 0,
        },
      },
    },
  }),
  { name: "Make-Actions" },
);
